/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Ten_MinutesInputs */



/**
* | output |
* | --- |
* | "You have been practising for 10 minutes." |
*
* @param {Practice_Session_Ten_MinutesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_ten_minutes = /** @type {((inputs?: Practice_Session_Ten_MinutesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Ten_MinutesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je oefent al 10 minuten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous vous entraînez depuis 10 minutes.")
	return /** @type {LocalizedString} */ ("You have been practising for 10 minutes.")
});